import ImportRepository from "@domain/repositories/ImportRepository";
import UseCase from "@domain/UseCase";
import { ImportHistory } from "@domain/models/ImportHistory";
import { ImportHistoryClient } from "@domain/models/ImportHistoryClient";

type Input = ImportHistory["id"];

type Output = Promise<ImportHistoryClient[]>;

export class GetImportHistoryClientsUseCase implements UseCase<Input, Output> {
  constructor(private readonly importRepository: ImportRepository) {}

  execute(importHistoryId: Input) {
    return this.importRepository.getImportHistoryClients(importHistoryId);
  }
}
